export default __webpack_public_path__ + "static/banner_m-031222a160e8a4dfda09708b6782430e.jpg";